/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectArticleAdded,
  selectArticleLoading, selectArticles, selectArticlesEnded,
  selectNextCall,
  selectPage, selectPaginationLoader,
} from 'Selector/FavoriteArticlesSelector';
import { Article } from 'Types/ArticleTypes';
import { actions } from 'Slice/FavoriteArticlesSlice';
import { Col, Row } from 'antd';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import InfiniteScroll from 'react-infinite-scroll-component';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import NavBarPrimary, { chatActions, chatStates } from 'Components/layout/headers/NavBarPrimary';
import GlobalSearch from 'Components/globalSearch/components/GlobalSearch';
import DrawerAlerts from 'Components/alerts/components/DrawerAlerts';
import AccountPopOver from 'Components/common/components/AccountPopOver';
import { useNavigate } from 'react-router-dom';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import styled from 'styled-components';
import { maxMobile, maxWidth, retina } from 'Utils/utilsStyle';
import { IsMobile, IsTablet } from 'Utils/UtilityFunctions';
import { selectShowGlobalGilroy } from 'Selector/GlobalSearchContentSelector';
import { actions as UiAction } from 'Slice/UISlice';
import ArticleGridLayout from 'Components/common/components/ArticleGridLayout';
import { Gilroy } from 'gilroy-global';
import { useGilroy } from 'Utils/hooks/useGilroy';

export const Column = styled(Col)`
  div{
    width: 875px;
    margin: 0 auto;
    text-align: center;
    height: calc(100vh - 140px);
    @media all and (max-width: ${maxWidth}) , ${retina} {
      width: 660px;
    }
    @media all and (max-width: ${maxMobile}) {
      width: 300px;
    }
  }
`;

const Favorites = function Favorites() {
  const { gilroyStates, gilroyActions } = useGilroy();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { saveUrl: savedUrlV2 } = chatStates;
  const loading: boolean = useSelector(selectArticleLoading);
  const favoriteArticles: Article[] = useSelector(selectArticles);
  const page: number = useSelector(selectPage);
  const articleEnded: boolean = useSelector(selectArticlesEnded);
  const isPagination = useSelector(selectPaginationLoader);
  const nextCall = useSelector(selectNextCall);
  const favoriteAdded = useSelector(selectArticleAdded);
  const showGlobalGilroy = useSelector(selectShowGlobalGilroy);
  const currentUrl = window.location.href;
  const isMobile = IsMobile();

  const fetchArticles = () => {
    const params = {
      offset: favoriteArticles.length,
    };
    dispatch(actions.getFavoriteArticles(params));
  };

  const fetchMore = () => {
    if (favoriteArticles.length > 0 && !loading) {
      fetchArticles();
    }
  };

  useEffect(() => {
    const params = {
      offset: favoriteArticles.length,
    };
    dispatch(actions.getFavoriteArticles(params));
    if (savedUrlV2 !== currentUrl) {
      dispatch(UiAction.isShowGilroyGlobalToggle(false));
      chatActions.setShowLibrary(true);
      chatActions.setShowExamplePrompts(false);
      chatActions.resetChatHistory();
      chatActions.setSelectedConversationId(-1);
      chatActions.setHistoryPanelOpened(false);
    } else {
      chatActions.setSaveUrl('');
      chatActions.setSaveProfileName('');
    }

    return () => {
      dispatch(actions.resetState());
    };
  }, []);

  useEffect(() => {
    if (nextCall && page !== 1 && !loading) {
      const params = {
        offset: favoriteArticles.length,
      };
      dispatch(actions.getFavoriteArticles(params));
    }
  }, [favoriteArticles, favoriteArticles.length, favoriteAdded]);

  return (
    <>
      <NavBarPrimary headerClassName="headers-space box-shadow no-overflow-on-header">
        <div className="left-side-wrap">
          <BackIcon onClick={() => navigate(-1)} />
          <h1 className="heading">Favorites</h1>
        </div>
        <div className="right-side-wrap">
          <GlobalSearch iconMode={IsTablet()} />
          <DrawerAlerts />
          <AccountPopOver />
        </div>

      </NavBarPrimary>
      <div className="container">
        {loading
          ? (
            <Row gutter={[16, 16]} id="tabs-details">
              <ArticleLoadingSkeletonBundle />
            </Row>
          )
          : (
            <>

              <div id="tabs-details">
                <InfiniteScroll
                  dataLength={favoriteArticles.length}
                  next={fetchMore}
                  hasMore={!articleEnded}
                  loader={false}
                  className="o-x-hidden o-y-hidden"
                >
                  {!loading ? (
                    <ArticleGridLayout
                      isLoading={isPagination}
                      articlesArray={favoriteArticles}
                    />
                  ) : (
                    <Column span={24} className="article-grid width-100">
                      <NoPersonsFound title="As you're exploring Sales Xelerator, you can easily favorite content by hitting the favorite icon. When you do they'll show up here." />
                    </Column>
                  )}
                </InfiniteScroll>
              </div>
              {
                isPagination && !articleEnded && (
                  <Row gutter={[16, 16]}>
                    <ArticleLoadingSkeletonBundle />
                  </Row>
                )
              }
            </>
          )}
      </div>
      {showGlobalGilroy
        ? (
          <Gilroy gilroyStates={gilroyStates} gilroyActions={gilroyActions} />
        ) : null}
    </>
  );
};

export default Favorites;
